import { useState, useEffect, useCallback } from 'react';
import { getOrdersByBeach, updateOrderStatus, cancelBookingAndRelease } from '../services/firebase';

export function useBookings(beachCode) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOrders = useCallback(async () => {
    console.log('fetchOrders called, beachCode:', beachCode);
    if (!beachCode) return;
    setLoading(true);
    try {
      const data = await getOrdersByBeach(beachCode);
      console.log('orders result:', data.length, data); // ← aggiungi
      setOrders(data);
    } catch (e) {
      console.error('orders error:', e); // ← aggiungi
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [beachCode]);

  useEffect(() => { fetchOrders(); }, [fetchOrders]);

  const cancel = async (orderId) => {
    const order = orders.find(o => o.id === orderId);
    if (order?.celle?.length || order?.areaQuantita) {
      // Ricava areaQuantita: da app orders (areaQuantita diretto) o da ordini manuali
      // (costruisce il dizionario dalla cella con tipo area e quantita)
      const areaQuantita =
        order.areaQuantita ||
        (order.isArea && order.servizioId
          ? { [order.servizioId]: order.celle?.[0]?.quantita || 1 }
          : {});
      await cancelBookingAndRelease(beachCode, orderId, order.celle || [], order.selectedDate, areaQuantita);
    } else {
      // Vecchia struttura legacy senza celle
      await updateOrderStatus(orderId, 'cancelled');
    }
    setOrders(prev => prev.map(o => o.id === orderId ? { ...o, status: 'cancelled' } : o));
  };

  const confirm = async (orderId) => {
    await updateOrderStatus(orderId, 'confirmed');
    setOrders(prev => prev.map(o => o.id === orderId ? { ...o, status: 'confirmed' } : o));
  };

  // Stats derivate — compatibili con entrambe le strutture
  const today = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`;

  const todayOrders = orders.filter(o =>
    o.selectedDate?.includes(today) && o.status !== 'cancelled'
  );
  // Incasso oggi: solo ordini `confirmed` (esclude blocked/pending/cancelled)
  // e prorata sulla singola giornata (totalPrice / numero giorni del range),
  // così una prenotazione stagionale non gonfia l'incasso di ogni singolo giorno.
  const todayRevenue = orders
    .filter(o => o.status === 'confirmed' && o.selectedDate?.includes(today))
    .reduce((sum, o) => {
      const days = Math.max(1, o.selectedDate?.length || 1);
      return sum + (o.totalPrice || 0) / days;
    }, 0);
  const pendingCount = orders.filter(o => o.status === 'pending').length;
  const cancelledThisWeek = orders.filter(o => {
    if (o.status !== 'cancelled') return false;
    const created = o.createdAt?.toDate?.() || new Date(0);
    return (Date.now() - created.getTime()) / 86400000 <= 7;
  }).length;

  return {
    orders, loading, error,
    refetch: fetchOrders,
    cancel, confirm,
    stats: { todayOrders, todayRevenue, pendingCount, cancelledThisWeek },
  };
}